"use client";
import Image from "next/image";
import Hls from "hls.js";
import { useEffect, useRef, useState } from "react";
import CustomVideoModal from "./custom-video-modal";

type CustomVideoCardProps = {
  coverImageSrc: string;
  videoLink: string;
  blue?: boolean;
};

export const CustomVideoCardBlue = ({
  blue = false,
  ...props
}: CustomVideoCardProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const videoPreviewRef = useRef<HTMLVideoElement>(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Load the HLS preview video for browsers without native HLS support
  useEffect(() => {
    const video = videoPreviewRef.current;
    const src = props.videoLink;
    if (!video || !src) return;

    // Safari: native HLS support, just set src directly
    if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = src;
      return;
    }

    // Chrome/Firefox/etc: use hls.js
    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(src);
      hls.attachMedia(video);
      return () => hls.destroy();
    }
  }, [props.videoLink]);

  return (
    <>
      <figure
        className="rounded-card relative"
        onClick={() => {
          openModal();
          videoPreviewRef.current?.pause();
        }}
      >
        <video
          width={413}
          height={542}
          ref={videoPreviewRef}
          poster={`https://images.pandahub.com/${props.coverImageSrc}`}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="aspect-[413/542] rounded-card min-w-[225px] object-cover"
          // no `src` attribute — handled by the effect above
        />
        <Image
          width={100}
          height={100}
          alt="Play button"
          src="2be6d928-db57-4c27-8f02-c7b0bd95723b.svg"
          className="aspect-square absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      </figure>
      <CustomVideoModal
        isOpen={isModalOpen}
        onClose={() => {
          closeModal();
          videoPreviewRef.current?.play();
        }}
        videoLink={props.videoLink}
      />
    </>
  );
};